import React from "react";

const SettingsSection = ({
  title,
  subtitle,
  children,
  className = "",
  headerRight,
  titleSuffix,
  noTopDivider,
  titleClassName = "mb-[6px]",
  "data-tour-id": dataTourId,
}) => (
  <div className={`mt-6 ${className}`}>
    {!noTopDivider && (
      <div className="mx-[20px] border-t border-[#ECECED] mb-[16px]" />
    )}
    <div data-tour-id={dataTourId} className={dataTourId ? "pt-2.5" : ""}>
      {title && (
        <div className={`px-[20px] ${titleClassName}`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <h3 className="text-[12px] font-bold text-[#636369] uppercase tracking-[0.05em]">
                {title}
              </h3>
              {titleSuffix}
            </div>
            {headerRight}
          </div>
          {subtitle && (
            <p className="mt-[2px] text-[12px] text-[#636369] leading-[18px]">
              {subtitle}
            </p>
          )}
        </div>
      )}
      <div className="bg-white">{children}</div>
    </div>
  </div>
);

export default React.memo(SettingsSection);
